import { t } from 'ttag';

import { Modal, ModalProps } from '@ui/Modal';
import Title from '@ui/Title';
import { SellerRatingModalContainer } from '@containers/SellerRatingModal';

import s from './SellerRatingModal.sss';

// types
type SellerRatingModalProps = ModalProps & {
  sellerId: number;
  isOpen: boolean;
  onRequestClose(): void;
};

export const SellerRatingModal: React.FC<SellerRatingModalProps> = ({
  sellerId,
  isOpen,
  onRequestClose,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    className={s.modal}
    withClose={true}
  >
    <Title type="h3" bold={false} className={s.title}>{t`Рейтинг продавця`}</Title>
    <SellerRatingModalContainer sellerId={sellerId} />
  </Modal>
);
